export function addCrc(buffer: Uint8Array, crc: number): Uint8Array {
  const crcBytes = new Uint8Array([(crc >> 8) & 0xff, crc & 0xff])
  return concatTypedArray(buffer, crcBytes)
}

export function crc16new(
  src: Uint8Array,
  polynomial = 0x1021,
  initialValue = 0,
  pad = true,
): number {
  let crc = initialValue
  const padding = pad ? 2 : 0
  let i = 0

  while (i < src.length + padding) {
    for (let b = 0; b < 8; b++) {
      const divide = crc & 0x8000
      crc = (crc << 1) & 0xffff

      if (i < src.length) {
        const byte = src[i]
        // const bit = (byte & (0x80 >> b)) ? 1 : 0;
        const bit = byte & (0x80 >>> b) ? 1 : 0
        crc |= bit
      }

      if (divide !== 0) {
        crc ^= polynomial
      }
    }
    i++
  }

  return crc
}

export function indexOfSubarrayFast(
  mainArray: Uint8Array,
  subArray: Uint8Array,
  fromIndex = 0,
): number {
  const mainBuffer = mainArray.buffer
  const subBuffer = subArray.buffer
  const mainLen = mainArray.length
  const subLen = subArray.length

  if (subLen === 0 || subLen > mainLen) return -1

  const maxSearchIndex = mainLen - subLen
  const view = new DataView(mainBuffer)
  const target = new DataView(subBuffer)

  // 逐字节比对内存
  outer: for (let i = fromIndex; i <= maxSearchIndex; i++) {
    for (let j = 0; j < subLen; j++) {
      if (view.getUint8(i + j) !== target.getUint8(j)) {
        continue outer
      }
    }
    return i
  }
  return -1
}

// 工具方法
export function concatTypedArray(a: Uint8Array, b: Uint8Array): Uint8Array {
  const tmp = new Uint8Array(a.length + b.length)
  tmp.set(a, 0)
  tmp.set(b, a.length)
  return tmp as unknown as Uint8Array
}

export function decodeBase64Uint8Array(base64Bytes: Uint8Array): Uint8Array {
  const base64Str = String.fromCharCode(...base64Bytes)
  const binaryStr = atob(base64Str)
  const payload = new Uint8Array(binaryStr.length)
  for (let i = 0; i < binaryStr.length; i++) {
    payload[i] = binaryStr.charCodeAt(i)
  }
  return payload as unknown as Uint8Array
}

export function crc16(src: Uint8Array, polynomial = 0x1021, initialValue = 0, pad = true): number {
  let crc = initialValue
  const padding = pad ? 2 : 0
  let i = 0

  while (i < src.length + padding) {
    for (let b = 0; b < 8; b++) {
      const divide = crc & 0x8000
      crc = (crc << 1) & 0xffff

      if (i < src.length) {
        const byte = src[i]
        const bit = byte & (0x80 >> b) ? 1 : 0
        crc |= bit
      }

      if (divide !== 0) {
        crc ^= polynomial
      }
    }
    i++
  }

  return crc
}

export function memcmpJS(a: Uint8Array | number[], b: Uint8Array | number[]): number {
  // 比较数组长度
  const minLen = Math.min(a.length, b.length)
  for (let i = 0; i < minLen; i++) {
    if (a[i] !== b[i]) {
      return a[i] - b[i] // 返回首个不同字节的差值
    }
  }
  // 若前面字节都相同，比较长度差异
  return a.length - b.length
}

export async function sha256(data: Uint8Array): Promise<Uint8Array> {
  // 使用 Web Crypto API 计算哈希
  const hashBuffer = await crypto.subtle.digest('SHA-256', data.slice(0))
  // 将结果转换为 Uint8Array
  return new Uint8Array(hashBuffer)
}
